
(function() {
  var result = { translations: { "en": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Actions" }, "tag": { "remove": "Remove tag" }, "Select": { "noResults": "No results found", "searchPlaceholder": "Search...", "clearSelections": "Clear selections" }, "ErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." }, "sessionId": { "prefix": "Session Id: " } }, "ProgressSteps": { "completedStep": "Completed step", "incompleteStep": "Incomplete step" }, "Paginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "Datagrid": { "noData": { "Title": "No data available", "Description": "There is no data available to display." }, "noResults": { "Title": "No results found", "Description": "Try adjusting your search and filters to find what you're looking for.", "ClearActionLabel": "Clear search and filters" }, "toolbar": { "selectedRows": { "one": "{{count}} row selected", "other": "{{count}} rows selected", "clearSelection": "Clear selection", "selectAll": "Select all {{totalRows}} rows" }, "search": { "placeholder": "Search", "label": "Search", "clearSearch": "Clear search" } }, "pagination": { "visibleRows": "{{visibleRows}} of {{totalRows}} results", "itemsPerPage": "Items per page", "countPerPage": { "one": "{{count}} per page", "other": "{{count}} per page" } }, "SkeletonGrid": { "loading": "Loading" }, "DataGridColumnManagementPanel": { "description": "Choose which properties to display as columns. Then, move properties up or down, or drag and drop, to change the order they will be displayed.", "removeAllColumns": "Remove all columns", "update": "Update", "cancel": "Cancel", "edit": "Edit columns" } } }, "ui": { "UIAbstractPageSection": { "page": "Page Section" }, "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIColorSwatch": { "label": "Color picker {{value}}", "noColorLabel": "Color picker, no color selected." }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "UISideNav": { "navigationLandmark": "Secondary" }, "UISortTH": { "ascendingSort": "Ascending sort. Press to sort descending.", "descendingSort": "Descending sort. Press to sort ascending.", "pressToSort": "Press to sort." }, "autosizedTextInput": { "charactersRemaining": "{{value}} characters remaining" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "dateSelected": "{{date}} is selected.", "noDateSelected": "No date selected.", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date", "invalidDate": "Invalid date", "today": "Today", "clear": "Clear", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" }, "nextMonth": "Next month", "prevMonth": "Previous month" }, "dateRange": { "startDate": "Start date", "endDate": "End date", "endDateBeforeStartDate": "The end date must come after the start date.", "startDateAfterEndDate": "The start date must come before the end date.", "to": "to" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026and {{count}} more.", "loadMore": "Load more" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Add" }, "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading\u2026" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" }, "clearButton": "Clear input" }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option \u201C{{label}}\u201D", "plusMore": "+ {{count}} more", "andMore": "\u2026and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITable": { "selectableTableRow": { "toggleSelection": "Toggle selection of the row" } }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "en": "static-1.4306"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.4306",
    "ar-eg": "static-1.4306",
    "bg": "static-1.4306",
    "bn": "static-1.4306",
    "ca-es": "static-1.4306",
    "cs": "static-1.4306",
    "da": "static-1.4306",
    "de": "static-1.4306",
    "el": "static-1.4306",
    "en-gb": "static-1.4306",
    "en": "static-1.4306",
    "es-mx": "static-1.4306",
    "es": "static-1.4306",
    "et": "static-1.4306",
    "fi": "static-1.4306",
    "fr-ca": "static-1.4306",
    "fr": "static-1.4306",
    "he-il": "static-1.4306",
    "hi": "static-1.4306",
    "hr": "static-1.4306",
    "hu": "static-1.4306",
    "id": "static-1.4306",
    "it": "static-1.4306",
    "ja": "static-1.4306",
    "ko": "static-1.4306",
    "lt": "static-1.4306",
    "ms": "static-1.4306",
    "nl": "static-1.4306",
    "no": "static-1.4306",
    "pl": "static-1.4306",
    "pt-br": "static-1.4306",
    "pt-pt": "static-1.4306",
    "ro": "static-1.4306",
    "ru": "static-1.4306",
    "sk": "static-1.4306",
    "sl": "static-1.4306",
    "sv": "static-1.4306",
    "th": "static-1.4306",
    "tl": "static-1.4306",
    "tr": "static-1.4306",
    "uk": "static-1.4306",
    "vi": "static-1.4306",
    "zh-cn": "static-1.4306",
    "zh-hk": "static-1.4306",
    "zh-tw": "static-1.4306"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:en', {version: 'static-1.4306'}); }
})();



(function() {
  var result = { translations: { "en": { "placeholder": "placeholder" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-3.6075"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6075",
    "ar-eg": "static-3.6075",
    "bg": "static-3.6075",
    "bn": "static-3.6075",
    "ca-es": "static-3.6075",
    "cs": "static-3.6075",
    "da": "static-3.6075",
    "de": "static-3.6075",
    "el": "static-3.6075",
    "en-gb": "static-3.6075",
    "en": "static-3.6075",
    "es-mx": "static-3.6075",
    "es": "static-3.6075",
    "et": "static-3.6075",
    "fi": "static-3.6075",
    "fr-ca": "static-3.6075",
    "fr": "static-3.6075",
    "he-il": "static-3.6075",
    "hi": "static-3.6075",
    "hr": "static-3.6075",
    "hu": "static-3.6075",
    "id": "static-3.6075",
    "it": "static-3.6075",
    "ja": "static-3.6075",
    "ko": "static-3.6075",
    "lt": "static-3.6075",
    "ms": "static-3.6075",
    "nl": "static-3.6075",
    "no": "static-3.6075",
    "pl": "static-3.6075",
    "pt-br": "static-3.6075",
    "pt-pt": "static-3.6075",
    "ro": "static-3.6075",
    "ru": "static-3.6075",
    "sk": "static-3.6075",
    "sl": "static-3.6075",
    "sv": "static-3.6075",
    "th": "static-3.6075",
    "tl": "static-3.6075",
    "tr": "static-3.6075",
    "uk": "static-3.6075",
    "vi": "static-3.6075",
    "zh-cn": "static-3.6075",
    "zh-hk": "static-3.6075",
    "zh-tw": "static-3.6075"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-3.6075'}); }
})();



(function() {
  var result = { translations: { "en": { "app": { "htmlTitle": "Viral Links UI", "welcomeHome": "Welcome home, {{ firstName }}", "yourAppIsReady": "Your app is ready", "aSecondPage": "A second page to hold more content", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Fill this empty page with ", createElement( options, "Link", props.linkProps, "components" ), " at ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Create your own free forms</strong> to generate leads from your website." }, "liveChat": { "linkCta": "<strong>Add live chat.</strong> Connect with visitors. Free.", "ariaLabel": "Add live chat. Connect with visitors. Free." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Add live chat.</strong> Connect with visitors. Free.", "ariaLabel": "[Int] Add live chat. Connect with visitors. Free." }, "meetings": { "linkCta": "<strong>Create your free meeting booking page</strong> to schedule meetings faster." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "en": "static-1.3662"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.3662",
    "ar-eg": "static-1.3662",
    "bg": "static-1.3662",
    "bn": "static-1.3662",
    "ca-es": "static-1.3662",
    "cs": "static-1.3662",
    "da": "static-1.3662",
    "de": "static-1.3662",
    "el": "static-1.3662",
    "en-gb": "static-1.3662",
    "en": "static-1.3662",
    "es-mx": "static-1.3662",
    "es": "static-1.3662",
    "et": "static-1.3662",
    "fi": "static-1.3662",
    "fr-ca": "static-1.3662",
    "fr": "static-1.3662",
    "he-il": "static-1.3662",
    "hi": "static-1.3662",
    "hr": "static-1.3662",
    "hu": "static-1.3662",
    "id": "static-1.3662",
    "it": "static-1.3662",
    "ja": "static-1.3662",
    "ko": "static-1.3662",
    "lt": "static-1.3662",
    "ms": "static-1.3662",
    "nl": "static-1.3662",
    "no": "static-1.3662",
    "pl": "static-1.3662",
    "pt-br": "static-1.3662",
    "pt-pt": "static-1.3662",
    "ro": "static-1.3662",
    "ru": "static-1.3662",
    "sk": "static-1.3662",
    "sl": "static-1.3662",
    "sv": "static-1.3662",
    "th": "static-1.3662",
    "tl": "static-1.3662",
    "tr": "static-1.3662",
    "uk": "static-1.3662",
    "vi": "static-1.3662",
    "zh-cn": "static-1.3662",
    "zh-hk": "static-1.3662",
    "zh-tw": "static-1.3662"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:en', {version: 'static-1.3662'}); }
})();


